export default "__VITE_ASSET__Da3l$4f0__"